import {
    defineMessages
} from 'react-intl';

export const messages = defineMessages({
    "Commission_MasterAgentRequirement": {
        "id": "Commission_Page.MasterAgentRequirement",
        "defaultMessage": "Requirement"
    },

    "Commission_Title_LM": {
        "id": "Commission_Page.Title_LM",
        "defaultMessage": "2 types of Multi-tier Commission Model"
    },
    "Commission_Title_CM": {
        "id": "Commission_Page.Title_CM",
        "defaultMessage": "Multi-tier commission model"
    },
    "Commission_Desc_LM": {
        "id": "Commission_Page.Desc_LM",
        "defaultMessage": "Calulation and settlement of affiliate commission is once a month and is based on the following two factors. First : Net Gaming Revenue , Second : Number of active members. Please refer to the table below for more details. "
    },
    "Commission_Desc_CM": {
        "id": "Commission_Page.Desc_CM",
        "defaultMessage": "Master Affiliate program (CM) is the second type of affiliate commission model whereby the Master Affiliate generates income from his downline affiliates. Master Affiliate can determine his sub affiliate's commission rate and earn the difference. Please refer to the below scenario as an example. \n\n"
    },
    "Commission_Desc_CM_2": {
        "id": "Commission_Page.Desc_CM_2",
        "defaultMessage": "\n Example : Master Affiliate A ( self ) is given 40% commission rate. He has  two sub affiliates downline , Sub Affiliate B and Sub Affiliate C. Master Affiliate A ( self )  allocates 30% commission rate to Sub Affiliate B and earns 10% of  commission from Sub Affiliate B and Sub Affiliate B's  downline.  Master Affiliate A ( Self ) allocates 35% commission to Sub Affiliate C and earns 5% of commission from Sub Affiliate C and Sub Affiliate's downline."
    },
    "Commission_Desc_CM_3": {
        "id": "Commission_Page.Desc_CM_3",
        "defaultMessage": "\n In this example, Sub Affiliate C  has two downlines, Sub Affiliate D and Sub Affiliate E who are both level 2 downline. Master Affiliate A ( Self ) will earn a total of 10% commission rate from Sub Affiliate B and 5% commssion rate from Sub Affiliate C who are both from level 1 and 5% commission rate from level 2 Sub Affiliate D and E respectively."
    },
    "Commission_Desc_CM_4": {
        "id": "Commission_Page.Desc_CM_4",
        "defaultMessage": "\n Total Income Earned: Sub Affiliate B Total NGR x 10%  + Sub Affiliate C Total NGR x 5% + Sub Affiliate D Total NGR x 5% + Sub Affiliate E Total NGR x 5%"
    },
    "Commission_Button_KnowMore": {
        "id": "Commission_Page.KnowMore",
        "defaultMessage": "Click to read full details"
    },
    "Commission_Table_H1Col1": {
        "id": "Commission_Page.H1Col1",
        "defaultMessage": "Company Total Net Gaming Revenue tier structure for the month"
    },
    "Commission_Table_H1Col1_1": {
        "id": "Commission_Page.H1Col1_1",
        "defaultMessage": "Company Total Net Gaming Revenue tier structure for the month"
    },
    "Commission_Table_H1Col2": {
        "id": "Commission_Page.H1Col2",
        "defaultMessage": "Minimum Active Players Directly <br/>under You to Qualify"
    },
    "Commission_Table_H1Col3": {
        "id": "Commission_Page.H1Col3",
        "defaultMessage": "Commission percentage rate"
    },
    "Commission_Table_H1Col4": {
        "id": "Commission_Page.H1Col4",
        "defaultMessage": "Company Total Net Gaming Revenue ({currency})"
    },
    "Commission_Table_H1Col5": {
        "id": "Commission_Page.H1Col5",
        "defaultMessage": "Your commission earned"
    },
    "Commission_Table_H1Col6": {
        "id": "Commission_Page.H1Col6",
        "defaultMessage": "Booster Rate"
    },
    "Commission_Table_H2Col1": {
        "id": "Commission_Page.H2Col1",
        "defaultMessage": "First RMB {memberLostFrom} – RMB {memberLostTo}"
    },
    "Commission_Table_H2Col2": {
        "id": "Commission_Page.H2Col2",
        "defaultMessage": "{minActiveMember}"
    },
    "Commission_Table_H2Col3": {
        "id": "Commission_Page.H2Col3",
        "defaultMessage": "{commissionRate}%"
    },
    "Commission_Table_H2Col4": {
        "id": "Commission_Page.H2Col4",
        "defaultMessage": "{exampleNGR}"
    },
    "Commission_Table_H2Col5": {
        "id": "Commission_Page.H2Col5",
        "defaultMessage": "{commissionEarned}"
    },
    "Commission_Table_H2Col6": {
        "id": "Commission_Page.H2Col6",
        "defaultMessage": "{boosterRate}"
    },
    "Commission_Table_H3Col1": {
        "id": "Commission_Page.H3Col1",
        "defaultMessage": "Next RMB {memberLostFrom} – RMB {memberLostTo}"
    },
    "Commission_Table_H3Col2": {
        "id": "Commission_Page.H3Col2",
        "defaultMessage": "{minActiveMember}"
    },
    "Commission_Table_H3Col3": {
        "id": "Commission_Page.H3Col3",
        "defaultMessage": "{commissionRate}%"
    },
    "Commission_Table_H3Col4": {
        "id": "Commission_Page.H3Col4",
        "defaultMessage": "{exampleNGR}"
    },
    "Commission_Table_H3Col5": {
        "id": "Commission_Page.H3Col5",
        "defaultMessage": "{commissionEarned}"
    },
    "Commission_Table_H3Col6": {
        "id": "Commission_Page.H3Col6",
        "defaultMessage": "{boosterRate}"
    },
    "Commission_Table_H4Col1": {
        "id": "Commission_Page.H4Col1",
        "defaultMessage": "Next {memberLostFrom} – RMB {memberLostTo}"
    },
    "Commission_Table_H4Col2": {
        "id": "Commission_Page.H4Col2",
        "defaultMessage": "{minActiveMember}"
    },
    "Commission_Table_H4Col3": {
        "id": "Commission_Page.H4Col3",
        "defaultMessage": "{commissionRate}%"
    },
    "Commission_Table_H4Col4": {
        "id": "Commission_Page.H4Col4",
        "defaultMessage": "{exampleNGR}"
    },
    "Commission_Table_H4Col5": {
        "id": "Commission_Page.H4Col5",
        "defaultMessage": "{commissionEarned}"
    },
    "Commission_Table_H4Col6": {
        "id": "Commission_Page.H4Col6",
        "defaultMessage": "{boosterRate}"
    },
    "Commission_Table_H5Col1": {
        "id": "Commission_Page.H5Col1",
        "defaultMessage": "Any amount above the first {memberLostFrom} "
    },
    "Commission_Table_H5Col1_1": {
        "id": "Commission_Page.H5Col1_1",
        "defaultMessage": "Next {memberLostFrom} - {memberLostTo} "
    },
    "Commission_Table_H5Col2": {
        "id": "Commission_Page.H5Col2",
        "defaultMessage": "{minActiveMember}"
    },
    "Commission_Table_H5Col3": {
        "id": "Commission_Page.H5Col3",
        "defaultMessage": "{commissionRate}%"
    },
    "Commission_Table_H5Col4": {
        "id": "Commission_Page.H5Col4",
        "defaultMessage": "{exampleNGR}"
    },
    "Commission_Table_H5Col5": {
        "id": "Commission_Page.H5Col5",
        "defaultMessage": "{commissionEarned}"
    },
    "Commission_Table_H5Col6": {
        "id": "Commission_Page.H5Col6",
        "defaultMessage": "{boosterRate}%"
    },
    "Commission_Table_H6Col1": {
        "id": "Commission_Page.H6Col1",
        "defaultMessage": "{Total}"
    },
    "Commission_Table_H6Col2": {
        "id": "Commission_Page.H6Col2",
        "defaultMessage": "-"
    },
    "Commission_Table_H6Col3": {
        "id": "Commission_Page.H6Col3",
        "defaultMessage": "-"
    },
    "Commission_Table_H6Col4": {
        "id": "Commission_Page.H6Col4",
        "defaultMessage": "{totalExampleNGR}"
    },
    "Commission_Table_H6Col5": {
        "id": "Commission_Page.H6Col5",
        "defaultMessage": "{totalCommossionEarned}"
    },
    "Commission_Table_H6Col6": {
        "id": "Commission_Page.H6Col6",
        "defaultMessage": "{boosterRate}"
    },
    "Commission_Table_H6Col1_1": {
        "id": "Commission_Page.H6Col1_1",
        "defaultMessage": "{memberLostFrom}"
    },
    "Commission_Table_H6Col2_1": {
        "id": "Commission_Page.H6Col2_1",
        "defaultMessage": "{minActiveMember}"
    },
    "Commission_Table_H6Col3_1": {
        "id": "Commission_Page.H6Col3_1",
        "defaultMessage": "{commissionRate}"
    },
    "Commission_Table_H6Col4_1": {
        "id": "Commission_Page.H6Col4_1",
        "defaultMessage": "{exampleNGR}"
    },
    "Commission_Table_H6Col5_1": {
        "id": "Commission_Page.H6Col5_1",
        "defaultMessage": "{commissionEarned}"
    },
    "Commission_PopUp_Calculation_LM": {
        "id": "Commission_Page.PopUp_Calculation_LM",
        "defaultMessage": "Gross Gaming Revenue ( GGR ) of Sportsbook + Casino + Slot + Lottery + Fishing Game + P2P \n- Marketing Cost (Player Bonuses + Player Rebates + Player Rewards) \n- Admin Cost \n- Payment Cost \n = Total Net Gaming Revenue ( Total NGR )  \n------------------------------ \n( Total NGR ) X % Commission Rate \n + sub affilaite earnings \n = Total earning \n------------------------------"
    },
    "Commission_PopUp_Calculation_CM": {
        "id": "Commission_Page.PopUp_Calculation_CM",
        "defaultMessage": "\n\n Example : Master Affiliate A ( self ) is given 40% commission rate. He has  two sub affiliates downline , Sub Affiliate B and Sub Affiliate C. Master Affiliate A ( self )  allocates 30% commission rate to Sub Affiliate B and earns 10% of  commission from Sub Affiliate B and Sub Affiliate B's  downline.  Master Affiliate A ( Self ) allocates 35% commission to Sub Affiliate C and earns 5% of commission from Sub Affiliate C and Sub Affiliate's downline.  \n\n"
    },
    "Commission_PopUp_SubAffiliateEarning_LM": {
        "id": "Commission_Page.PopUp_SubAffiliateEarning_LM",
        "defaultMessage": "Sub affiliate earning"
    },
    "Commission_PopUp_SubAffiliateEarning_Desc_LM": {
        "id": "Commission_Page.PopUp_SubAffiliateEarning_Desc_LM",
        "defaultMessage": "Affiliate generates revenue from two potential revenue streams: \n1. Company Total Net Gaming Revenue ( Total NGR ) from direct referral player \n2. Sub affiliate earning \n\nExample: \nYour sub affiliate total comissions= 10,000 \nYour sub affilite earning = 10,000 * 10% = 1,000 \n"
    },
    "Commission_PopUp_SubAffiliateEarning_Desc_LM_Additional": {
        "id": "Commission_Page.PopUp_SubAffiliateEarning_Desc_LM_Additional",
        "defaultMessage": "As long as your direct affiliates recruit other affiliates ,you will have a share of the commissions from the downline affiliates of your direct affiliate. In conclusion, the more active members you have, the more commission you will get, and the more sub affiliates you have, it will also increase your total commission from sub affiliate earning. \nFun88 will pay you  10% from your direct affiliate and 1% from your direct affiliate's downline earning. \nExample: \nYour direct affiliate comissions= 10,000 \nYour commission will be= 10% * 10,000 = 1,000\nYour direct affiliate's downline commission = 10,000  \nYour commission will be= 1% * 10,000 = 100 \nYour total sub affiliate earning will be 1,000 + 100 = 1,100"
    },
    "Commission_PopUp_SubAffiliateEarning_Desc_CM": {
        "id": "Commission_Page.PopUp_SubAffiliateEarning_Desc_CM",
        "defaultMessage": "1. Master affiliate is mandatory to meet the requirements above to retain the commission rate and FUN88 has a set of rules to determine member's quality. If the member didn't meet the standard or master affiliate failed to meet the requirement, FUN88 has right to hold back the commission withdrawal. \n2. All master affiliate are required to meet the requirement above within 3 months upon registration. \n3. Master affiliate's commission rate will be adjusted or be removed if the performance standards are not met. \n4. Sub affilite's commission rate cannot be higher than master affiliate's commission rate"
    },
    "Commission_PopUp_Payment_LM": {
        "id": "Commission_Page.PopUp_Payment_LM",
        "defaultMessage": "Payment methods"
    },
    "Commission_PopUp_Payment_Desc_LM": {
        "id": "Commission_Page.PopUp_Payment_Desc_LM",
        "defaultMessage": "Commission will be transferred to your bank account automatically, with your stated personal information and your bank account."
    },
    "Commission_PopUp_Payment_Desc_CM": {
        "id": "Commission_Page.PopUp_Payment_Desc_CM",
        "defaultMessage": "Fun88 will monitor master affiliate for 3 months, if master can't meet the requirment, account will be closed"
    },
    "Commission_PopUp_JoinUsNow_LM": {
        "id": "Commission_Page.JoinUsNow_LM",
        "defaultMessage": "Join us now"
    },
    "Commission_Top_Btn_LM": {
        "id": "Commission_Page.Top_Btn_LM",
        "defaultMessage": "LM"
    },
    "Commission_Top_Btn_CM": {
        "id": "Commission_Page.Top_Btn_CM",
        "defaultMessage": "CM"
    },
    "Commission_Table_CM_H1Col1": {
        "id": "Commission_Page.CMH1Col1",
        "defaultMessage": "Master affiliate A"
    },
    "Commission_Table_CM_H1Col2": {
        "id": "Commission_Page.CMH1Col2",
        "defaultMessage": "Sub affiliate commission percentage"
    },
    "Commission_Table_CM_H2Col1": {
        "id": "Commission_Page.CMH2Col1",
        "defaultMessage": "Sub affiliate B"
    },
    "Commission_Table_CM_H2Col2": {
        "id": "Commission_Page.CMH2Col2",
        "defaultMessage": "10%"
    },
    "Commission_Table_CM_H3Col1": {
        "id": "Commission_Page.CMH3Col1",
        "defaultMessage": "Sub affiliate C"
    },
    "Commission_Table_CM_H3Col2": {
        "id": "Commission_Page.CMH3Col2",
        "defaultMessage": "5%"
    },
    "Commission_Table_CM_H4Col1": {
        "id": "Commission_Page.CMH4Col1",
        "defaultMessage": "Sub affiliate D"
    },
    "Commission_Table_CM_H4Col2": {
        "id": "Commission_Page.CMH4Col2",
        "defaultMessage": "10%"
    },
    "Commission_Table_CM_H5Col1": {
        "id": "Commission_Page.CMH5Col1",
        "defaultMessage": "Sub affiliate E"
    },
    "Commission_Table_CM_H5Col2": {
        "id": "Commission_Page.CMH5Col2",
        "defaultMessage": "5%"
    },
    "Commission_Table_CM2_H1Col1": {
        "id": "Commission_Page.CM2H1Col1",
        "defaultMessage": "Monthly minimum turnover "
    },
    "Commission_Table_CM2_H1Col2": {
        "id": "Commission_Page.CM2H1Col2",
        "defaultMessage": "Monthly minimum active menber "
    },
    "Commission_Table_CM2_H1Col3": {
        "id": "Commission_Page.CM2H1Col3",
        "defaultMessage": "Percentage rate"
    },
    "Commission_Table_CM2_H2Col1": {
        "id": "Commission_Page.CM2H2Col1",
        "defaultMessage": "8,000,000 RMB"
    },
    "Commission_Table_CM2_H2Col2": {
        "id": "Commission_Page.CM2H2Col2",
        "defaultMessage": "35"
    },
    "Commission_Table_CM2_H2Col3": {
        "id": "Commission_Page.CM2H2Col3",
        "defaultMessage": "0.4"
    },

    "Commission_Common_Reminder": {
        "id": "Common.Reminder",
        "defaultMessage": "Reminder"
    },

    "Commission_CM_RequirementNote": {
        "id": "Commission_Page.CMRequirement_Note",
        "defaultMessage": "*For higher commission rate, please approach FUN88 agent."
    },

    "Commission_Reminder": {
        "id": "Commission_Page.Reminder",
        "defaultMessage": "1. Master affiliate is mandatory to meet the requirements above to retain the commission rate and FUN88 has a set of rules to determine member's quality. If the member didn't meet the standard or master affiliate failed to meet the requirement, FUN88 has right to hold back the commission withdrawal. \n2. All master affiliate are required to meet the requirement above within 3 months upon registration. \n3. Master affiliate's commission rate will be adjusted or be removed if the performance standards are not met. \n4. Sub affilite's commission rate cannot be higher than master affiliate's commission rate."
    },
    "Commission_Page_PopUp_Title_LM": {
        "id": "Commission_Page.PopUp_Title_LM",
        "defaultMessage": "Multi-tier commission model"
    },
    "Commission_Table_H1Col4_1": {
        "id": "Commission_Page.H1Col4_1",
        "defaultMessage": "Unit is 1000 VND"
    }
})